
define('text!modules/targeting/digital/templates/grid_subitem.html',[],function () { return '{{#group}}\n<div class="group-name">\n    <span class="group-c">{{group}}</span>\n</div>\n{{/group}}\n{{#list}}\n    {{>listItem}}\n{{/list}}\n';});

